const icePattern = /(CLIPSTUDIO|CLIP STUDIO PAINT)\/(\d+\.\d+\.\d+)/;

export default new class Ice {
  isIce() {
    return icePattern.test(navigator.userAgent);
  }

  callIce(methodName, params = {}) {
    if (!this.isIce()) {
      return;
    }

    let uri = "callice://" + methodName;
    if (params) {
      for (const paramName in params) {
        uri +=
          "/" +
          encodeURIComponent(paramName) +
          "/" +
          encodeURIComponent(params[paramName]);
      }
    }

    location.href = uri;
  }

  openUrl(url, isViewInBrowser) {
    let params = { url: url };
    if (isViewInBrowser) {
      params = { ...params, view: "browser" };
    }
    this.callIce("openUrl", params);
  }

  showLogin(url = location.href, cancelUrl = location.href) {
    const params = {
      url: url,
      cancelUrl: cancelUrl
    };
    this.callIce("showLoginDialog", params);
  }

  setActiveMenu(menu) {
    this.callIce("setActiveMenu", { menu: menu });
  }

  inModal() {
    const modal = document.createElement("div");
    modal.id = "iceModalWall";
    modal.style;
    modal.setAttribute(
      "style",
      "z-index:9999; position:fixed; width:100%; height:100%; background-color:#000000; opacity:0.5; top:0; left:0;"
    );
    document.body.appendChild(modal);
  }

  outModal() {
    const modal = document.getElementById("iceModalWall");
    if (modal) {
      document.body.removeChild(modal);
    }
  }

  onClickLink(event) {
    if (this.isIce()) {
      event.preventDefault();
      this.openUrl(
        event.currentTarget.href,
        event.currentTarget.target == "_blank"
      );
    }
  }
}();
